// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2a729582","95":"98efae5a","208":"53f0fe1c","224":"90550bce","239":"a47ce104","288":"3e6580c5","367":"2ca85e10","407":"2c682240","528":"8bccc6a0","590":"983196a1","625":"d31926db","657":"9e8d6353","658":"a9b9270f","689":"5ba9d7e7","783":"45996838","927":"799bdbe0"}[chunkId] + ".chunk.js";
};